/* eslint-disable no-unused-vars */
// src/api/auth.js
import { notifySessionExpired } from "../utils/sessionBus";
const BASE_URL = 'https://dev-api.curu.com.au/api';

export const requestVerificationCode = async (email) => {
    try {
      console.log('Requesting verification code for:', email);
      console.log('API endpoint:', `${BASE_URL}/auth/verify/`);
      
      const response = await fetch(`${BASE_URL}/auth/verify/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      });
  
      console.log('Response status:', response.status);
      
      const responseText = await response.text();
      console.log('Raw server response:', responseText);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        console.error('Failed to parse response as JSON:', e);
        throw new Error('Server returned invalid response format. Please try again later.');
      }
  
      if (!response.ok) {
        throw new Error(data.message || 'Failed to send verification code');
      }
  
      return data;
    } catch (error) {
      console.error('Error requesting verification code:', error);
      throw error;
    }
  };

export const googleSignIn = async (email) => {
    try {
        const response = await fetch('https://dev-api.curu.com.au/api/v2/verify/social-user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                social_account: 'Gmail'
            })
        });

        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(`Failed to sign in with Google: ${errorResponse.message || response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Google Sign-In error:', error);
        throw error;
    }
};

export const facebookSignIn = async (email) => {
    try {
        const response = await fetch('https://dev-api.curu.com.au/api/v2/verify/social-user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email,
                social_account: 'Facebook',
                app_user_id: '997911069179651'
            })
        });

        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(`Failed to sign in with Facebook: ${errorResponse.message || response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Facebook Sign-In error:', error);
        throw error;
    }
};

export const appleSignIn = async (appleAuthData) => {
    try {
        // Add console log to see what data is being sent
        console.log('Apple auth data being sent:', {
            email: appleAuthData.email,
            social_account: 'Apple',
            id_token: appleAuthData.id_token ? appleAuthData.id_token.substring(0, 20) + '...' : null, // Log partial token for security
            code: appleAuthData.code ? appleAuthData.code.substring(0, 20) + '...' : null // Log partial code for security
        });

        const response = await fetch('https://dev-api.curu.com.au/api/v2/verify/social-user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: appleAuthData.email,
                social_account: 'Apple',
                id_token: appleAuthData.id_token,
                code: appleAuthData.code,
                client_id: 'com.curu.au' 
            })
        });

        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(`Failed to sign in with Apple: ${errorResponse.message || response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Apple Sign-In error:', error);
        throw error;
    }
};


export const createOrUpdateProfile = async (formData) => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found. Please log in again.');
    }

    try {
        // Check if the user already has a profile
        const profileResponse = await fetch('https://dev-api.curu.com.au/api/profile', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        let userProfile;

        if (profileResponse.ok) {
            userProfile = await profileResponse.json();
            console.log('User already has a profile:', userProfile);

            // Update the existing profile with the new email and other details
            const updateResponse = await fetch('https://dev-api.curu.com.au/api/profile', {
                method: 'PATCH', // Use PATCH to update the existing profile
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData, // send the FormData object
            });

            if (!updateResponse.ok) {
                const errorResponse = await updateResponse.json();
                throw new Error(`Failed to update profile: ${errorResponse.message || updateResponse.statusText}`);
            }

            userProfile = await updateResponse.json();
            console.log('Profile updated successfully:', userProfile);
            
        } else {
            // If the profile doesn't exist, create one
            console.log('No existing profile found, creating a new profile.');
            const createResponse = await fetch('https://dev-api.curu.com.au/api/profile', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },

                body: formData, // Send the FormData object
            });

            if (!createResponse.ok) {
                const errorResponse = await createResponse.json();
                console.error('Error response from API while creating profile:', errorResponse);
                throw new Error(`Failed to create profile: ${errorResponse.message || createResponse.statusText}`);
            }

            userProfile = await createResponse.json();
            console.log('Profile created successfully:', userProfile);
        }

        return userProfile;

    } catch (error) {
        console.error('Profile creation/update error:', error);
        throw error;
    }
};

export const getProfileInfo = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      notifySessionExpired();
      throw new Error("No token found. Please log in again.");
    }

    try {
        const profileResponse = await fetch('https://dev-api.curu.com.au/api/profile', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return profileResponse;

    } catch (error) {
        console.error('Profile creation/update error:', error);
        throw error;
    }
};

// Check username wherever exist
export const updateProfileUsername = async (username) => {
  if (typeof username !== "string" || username.trim() === "") {
    const e = new Error("Username is required");
    e.status = 400;
    throw e;
  }

  const token = localStorage.getItem("token");
  if (!token) {
    const e = new Error("No token found. Please log in again.");
    e.status = 401;
    throw e;
  }

  const res = await fetch(`${BASE_URL}/profile`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: JSON.stringify({ username: username.trim() }),
    credentials: "include",
  });

  // 204 is considered successful even without any content
  if (res.ok) {
    try {
      return await res.json();
    } catch {
      return null;
    }
  }

  // Parse backend errors when failure occurs (compatible with detail packages)
  let data = null;
  try { data = await res.json(); } catch {}

  const detail = data?.detail ?? data ?? {};
  const err = new Error(
    (Array.isArray(detail?.username) && detail.username[0]) ||
    (typeof detail?.username === "string" && detail.username) ||
    detail?.message ||
    "Failed to update username"
  );
  err.status = res.status;
  err.data = data;
  throw err;
};

// Delete the currently logged-in user
export const deleteMyAccount = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    const e = new Error("Not authenticated");
    e.status = 401;
    throw e;
  }

  const urls = [
    `${BASE_URL}/v2/delete-user/`,
    `${BASE_URL}/v2/delete-user`,
  ];

  const headerVariants = [
    { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    { Accept: "application/json", "Content-Type": "application/json", Authorization: `Token ${token}` },
  ];

  for (const headers of headerVariants) {
    for (const url of urls) {
      const resp = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify({ confirm: true }),
        credentials: "include", 
      });

      let data = null;
      try { data = await resp.json(); } catch {}

      if (resp.ok) {
        // It might be that 204 has no content, or 200/202 returns JSON
        return data;
      }

      // Authentication/permission issues are directly thrown as errors
      if (resp.status === 401 || resp.status === 403) {
        const e = new Error(data?.detail || data?.message || `Failed (HTTP ${resp.status})`);
        e.status = resp.status; e.data = data;
        throw e;
      }
    }
  }

  const e = new Error("DELETE user endpoint not reachable. (Tried /v2/delete-user[/])");
  e.status = 404;
  throw e;
};
